import { useEffect } from "react";

const CHATBOT_SCRIPT_SRC = "https://v3.chatbot.andyreach.com/static/widget-pro.js";
const CHATBOT_SCRIPT_SELECTOR = `script[src="${CHATBOT_SCRIPT_SRC}"]`;
const CHATBOT_OVERRIDES_ID = "andy-chatbot-viewport-overrides";

/*
  <script
    src="https://v3.chatbot.andyreach.com/static/widget-pro.js"
    data-bot-id="bot1"
    data-title="Andy AI"
    data-color="#22c55e">
  </script>
*/

const CHATBOT_VIEWPORT_OVERRIDES = `
.ap__panel {
  width: min(400px, calc(100vw - 32px));
  max-width: calc(100vw - 32px);
  height: min(640px, calc(100dvh - 112px));
  max-height: calc(100dvh - 112px);
  right: max(16px, env(safe-area-inset-right, 0px));
  bottom: max(96px, calc(68px + 16px + env(safe-area-inset-bottom, 0px)));
  top: auto;
}

.ap__bubble {
  right: max(16px, env(safe-area-inset-right, 0px));
  bottom: max(24px, env(safe-area-inset-bottom, 0px));
}

.ap__wrap,
.ap__wrap * {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
}

/* Widget appends a bare file input to body for uploads — hide it without breaking .click() */
body > input[type="file"][accept="image/*,.pdf"] {
  position: fixed;
  left: -10000px;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
}

@media (max-width: 480px) {
  .ap__panel {
    width: calc(100vw - 24px);
    max-width: calc(100vw - 24px);
    height: calc(100dvh - 96px);
    max-height: calc(100dvh - 96px);
    right: max(12px, env(safe-area-inset-right, 0px));
    bottom: max(76px, calc(60px + 16px + env(safe-area-inset-bottom, 0px)));
  }

  .ap__bubble {
    right: max(12px, env(safe-area-inset-right, 0px));
    bottom: max(16px, env(safe-area-inset-bottom, 0px));
  }
}
`;

const injectChatbotViewportOverrides = () => {
  if (document.getElementById(CHATBOT_OVERRIDES_ID)) return;

  const style = document.createElement("style");
  style.id = CHATBOT_OVERRIDES_ID;
  style.textContent = CHATBOT_VIEWPORT_OVERRIDES;
  document.head.appendChild(style);
};

export const ChatbotWidget = () => {
  useEffect(() => {
    const existingScript = document.querySelector(CHATBOT_SCRIPT_SELECTOR);

    if (existingScript) {
      injectChatbotViewportOverrides();
      return;
    }

    const script = document.createElement("script");
    script.src = CHATBOT_SCRIPT_SRC;
    script.setAttribute("data-bot-id", "bot1");
    script.setAttribute("data-title", "Andy AI");
    script.setAttribute("data-color", "#22c55e");
    script.async = true;
    script.onload = injectChatbotViewportOverrides;
    document.body.appendChild(script);
  }, []);

  return null;
};
